import Cookies from 'js-cookie'
import * as restlet from '@/store/actions/rest'
import * as types from '@/store/event_types'
import store from '@/store'

export default function auth(to, from, next){
  if (Cookies.get('user')){
    next()
  } else {
      restlet.getLoggedInUser().then(function(response) {
          if (response.status === 200){
              store.commit(types.SET_USER, response.data)
              next()
          } else if (response.status === 401) {
            location.href=process.env.VUE_APP_LOGIN_URI + "?" + to.fullPath
          }
      })
  }
}
